import { Server as ServerV3_0 } from '@criteria/openapi/v3.0'
import { Server as ServerV3_1 } from '@criteria/openapi/v3.1'
import { Change, OpenAPI } from './Change'

export type Server = ServerV3_0 | ServerV3_1

export class InsertServer extends Change {
  constructor(readonly index: number, readonly value: Server) {
    super()
  }

  apply(document: OpenAPI) {
    document.servers ??= []
    document.servers.splice(this.index, 0, this.value)
  }
}

export class RemoveServer extends Change {
  constructor(readonly index: number, readonly deleteArrayIfEmpty: boolean) {
    super()
  }

  apply(document: OpenAPI) {
    let servers = document.servers ?? []
    servers.splice(this.index, 1)
    if (servers.length === 0 && this.deleteArrayIfEmpty) {
      delete document.servers
    }
  }
}
